"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var TrashOpen32 = function (props) { return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    react_1.default.createElement("path", { d: "M16.002 2.148a1.502 1.502 0 011.747 1.216l.086.491 5.427-.956a.987.987 0 011.122.702l.027.116.172.975a.995.995 0 01-.8 1.162L11.607 8h11.438c.841 0 1.494.686 1.445 1.523l-.936 16.013A1.573 1.573 0 0121.99 27H10.004a1.57 1.57 0 01-1.562-1.466l-.89-16.013a1.439 1.439 0 01.23-.872.992.992 0 01-.925-.831l-.172-.976a.995.995 0 01.8-1.161l5.426-.957-.086-.492a1.498 1.498 0 011.083-1.707l.143-.033zM23.045 9H9a.433.433 0 00-.45.466l.89 16.013a.57.57 0 00.563.521H21.99c.293 0 .55-.24.566-.523l.936-16.013A.432.432 0 0023.045 9zM20 11a.5.5 0 01.5.5v11.51a.5.5 0 01-1 0V11.5a.5.5 0 01.5-.5zm-8 0a.5.5 0 01.5.5v11.51a.5.5 0 01-1 0V11.5a.5.5 0 01.5-.5zm4 0a.5.5 0 01.5.5v11.51a.5.5 0 01-1 0V11.5a.5.5 0 01.5-.5zm7.428-7.115l-7.73 1.363-2.12.374-.493.087-5.419.955.004.005.172.975-.002.005 15.761-2.78-.002-.003-.172-.976.001-.005zm-9.532.665l-.492.087.58.406-.088-.493zm2.372-1.425l-.092.008-1.951.344a.5.5 0 00-.415.581l.086.492 2.954-.521-.086-.492a.5.5 0 00-.496-.412zm1.075.818l-.493.086.088.493.405-.58z", className: "trash-open-32_svg__path-1" }))); };
var StyledTrashOpen32 = styled_components_1.default(TrashOpen32)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"], ["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"])), function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var stroke = _a.stroke;
    return stroke && "stroke: " + stroke + "; stroke-width: 64;";
});
exports.default = StyledTrashOpen32;
var templateObject_1;
//# sourceMappingURL=TrashOpen32.js.map